// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"52":"a787e4c6","414":"ce3017b0","678":"cfd1a56e"}[chunkId] + ".css";
};